import { useEffect, useState } from "react";

export const useOnceAfterCondition = (
  cb: () => void,
  refresh: any[],
  condition: any
) => {
  const [hasRun, setHasRun] = useState(false);

  useEffect(() => {
    if (!condition || hasRun) return;

    setHasRun(true);
    cb();
  }, [refresh]);
};
